module.exports = __webpack_public_path__ + "img/icon_hio_wghn.85232b21.svg";